// Feature flags configuration
const FEATURE_FLAGS = {
  // Enable SaaS-style onboarding (disabled by default, keeping current Calendly behavior)
  SAAS_ONBOARDING: process.env.REACT_APP_ENABLE_SAAS_ONBOARDING === 'true' || false,
  
  // Progressive launch feature flags
  ROI_CALCULATION_ENABLED: process.env.REACT_APP_ENABLE_ROI_CALCULATION === 'true' || false,
  SITE_ASSESSMENT_REACT_FLOW: process.env.REACT_APP_ENABLE_SITE_ASSESSMENT_FLOW === 'true' || false,
  HARDWARE_DEPLOYMENT_ENABLED: process.env.REACT_APP_ENABLE_HARDWARE_DEPLOYMENT === 'true' || false,
  SYSTEM_COMMISSIONING_ENABLED: process.env.REACT_APP_ENABLE_SYSTEM_COMMISSIONING === 'true' || false,
  COMPREHENSIVE_BUSINESS_CASE: process.env.REACT_APP_ENABLE_COMPREHENSIVE_BUSINESS_CASE === 'true' || false,
  DASHBOARD_ANALYTICS_ENABLED: process.env.REACT_APP_ENABLE_DASHBOARD_ANALYTICS === 'true' || false,
  
  // Dashboard section feature flags
  DASHBOARD_TEAM_ENABLED: process.env.REACT_APP_ENABLE_DASHBOARD_TEAM === 'true' || false,
  DASHBOARD_BILLING_ENABLED: process.env.REACT_APP_ENABLE_DASHBOARD_BILLING === 'true' || false,
  DASHBOARD_SETTINGS_ENABLED: process.env.REACT_APP_ENABLE_DASHBOARD_SETTINGS === 'true' || false,
  SUBSCRIPTION_MANAGEMENT_ENABLED: process.env.REACT_APP_ENABLE_SUBSCRIPTION_MANAGEMENT === 'true' || false,
};

export const isFeatureEnabled = (flag) => {
  return FEATURE_FLAGS[flag] || false;
};

export const getServiceManagerUrl = () => {
  return process.env.REACT_APP_SERVICE_MANAGER_URL || 'https://motionlogic.xyz/service-manager/v1';
};

export default FEATURE_FLAGS;
